import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';
import { createJpdExperience } from '../../utils/experience/main.tsx';
import type { ExperienceErrorReason, JPDExperience } from '../../utils/experience/types.tsx';

export const pageSegmentLoad: JPDExperience = createJpdExperience(
	new UFOExperience('jpd.idea-view', {
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
	}),
);

// separate metric for loading fullscreen Idea View on start
export const directPageSegmentLoad = createJpdExperience(
	new UFOExperience('jpd.idea-view-direct', {
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
	}),
);

export const summaryUpdate = createJpdExperience(
	new UFOExperience('jpd.idea-view.summary-update', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const descriptionUpdate = createJpdExperience(
	new UFOExperience('jpd.idea-view.description-update', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export type JpdExperienceDeliveryTicketCreateMetadata = {
	metadata: {
		isRemoteLinked: boolean;
		renderingLocation?: 'idea-view' | 'tab-overview' | 'tab-delivery';
	};
};

export const deliveryTicketCreate = createJpdExperience<
	ExperienceErrorReason,
	JpdExperienceDeliveryTicketCreateMetadata
>(
	new UFOExperience('jpd.idea-view.delivery-ticket-create', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export type JpdExperienceDeliveryTicketExpandMetadata = {
	metadata: {
		isRemoteLinked: boolean;
	};
};

export const deliveryTicketExpand = createJpdExperience<
	ExperienceErrorReason,
	JpdExperienceDeliveryTicketExpandMetadata
>(
	new UFOExperience('jpd.idea-view.delivery-ticket-expand', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const commentCreate = createJpdExperience(
	new UFOExperience('jpd.idea-view.comment-create', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const insightCreate = createJpdExperience(
	new UFOExperience('jpd.idea-view.insight-create', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const insightUpdate = createJpdExperience(
	new UFOExperience('jpd.idea-view.insight-update', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const insightDelete = createJpdExperience(
	new UFOExperience('jpd.idea-view.insight-delete', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export type JpdExperienceIssueLinkCreateMetadata = {
	metadata: {
		isRemoteLinked: boolean;
		renderingLocation?: 'idea-view' | 'tab-overview' | 'tab-delivery';
	};
};

export const issueLinkCreate = createJpdExperience<
	ExperienceErrorReason,
	JpdExperienceIssueLinkCreateMetadata
>(
	new UFOExperience('jpd.idea-view.issue-link-create', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export type JpdExperienceIssueLinkDeleteMetadata = {
	metadata: {
		isRemoteLinked: boolean;
		renderingLocation?: 'idea-view' | 'tab-overview' | 'tab-delivery';
	};
};

export const issueLinkDelete = createJpdExperience<
	ExperienceErrorReason,
	JpdExperienceIssueLinkDeleteMetadata
>(
	new UFOExperience('jpd.idea-view.issue-link-delete', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const commentsSegmentLoad = createJpdExperience(
	new UFOExperience('jpd.idea-view.comments', {
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
	}),
);

export const insightsSegmentLoad = createJpdExperience(
	new UFOExperience('jpd.idea-view.insights', {
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
	}),
);

export const fileAttach = createJpdExperience(
	new UFOExperience('jpd.idea-view.attach-file', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const connectionsSegmentLoad = createJpdExperience(
	new UFOExperience('jpd.idea-view.connections-tab', {
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
	}),
);

/**
 * Since field updates can be frequent, makeFieldUpdate is a factory
 * to avoid conccurency problems as JPDExperience objects are singletons.
 */
export const makeFieldUpdate = () =>
	createJpdExperience(
		new UFOExperience('jpd.idea-view.field-update', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);
